import type { RouteLocationNormalizedGeneric } from 'vue-router'

import { useListsStore } from '@shared/model'
import { useListsApi } from '@shared/api'

/** The lists come back from the last visit at once, so a page middleware awaiting `ensure()` holds nothing on a
 *  reload; the read started here then brings them up to date in the background. */
export default defineNuxtRouteMiddleware((to: RouteLocationNormalizedGeneric, from: RouteLocationNormalizedGeneric) => {
  const listsStore = useListsStore()

  listsStore.hydrateFromStorage()

  if (to.path === from.path && listsStore.hasData) return

  void useListsApi()
})
